import { Controller } from 'stimulus';

export default class TabsController extends Controller {
  static targets = ['scrollShadowLeft', 'scrollShadowRight', 'scrollContainer'];

  connect() {
    this.handleScroll(this.scrollContainerTarget);
    this.scrollContainerTarget.addEventListener('scroll', (e) =>
      this.handleScroll(e.target),
    );
  }

  handleScroll = ({ scrollLeft, scrollWidth, clientWidth }) => {
    const TOLERANCE = 1;

    this.scrollShadowLeftTarget.classList.toggle(
      'transparent',
      scrollLeft <= TOLERANCE,
    );

    const isAtRightEnd = scrollLeft + clientWidth >= scrollWidth - TOLERANCE;
    this.scrollShadowRightTarget.classList.toggle('transparent', isAtRightEnd);
  };
}
